import enums from "../../common/lib/enums";

const { audit } = enums.status;

/**
 * Per-status action flags, keyed by the status id (enums.status.audit).
 * Never key this by status name: the API returns names in the user's language.
 */
export default {
    [audit.awaitingDownload]: {
        text: "edit",
        reminderEmail: true,
        canEdit: true,
        abandonAudit: false
    },
    [audit.pendingCount]: {
        text: "edit",
        reminderEmail: true,
        canEdit: true,
        abandonAudit: false
    },
    [audit.partiallyCompleteCount]: {
        text: "edit",
        reminderEmail: true,
        canEdit: true,
        abandonAudit: true
    },
    [audit.pendingReview]: {
        text: "start",
        reminderEmail: false,
        canEdit: false,
        abandonAudit: true
    },
    [audit.inReview]: {
        text: "resume",
        reminderEmail: false,
        canEdit: false,
        abandonAudit: true
    },
    [audit.closed]: {
        text: "view",
        reminderEmail: false,
        canEdit: false,
        abandonAudit: false
    }
};
